if (!customElements.get('quickview-modal')) {
  class Quickview extends HTMLElement {
    selectors = {
      trigger: '[data-action="quickview"]',
      close: '[data-action="quickview-close"]',
      modal: '.quickview',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.addTriggerListeners();

      document.addEventListener('quickview:refresh', this.addTriggerListeners.bind(this));

      document.addEventListener('keydown', this.handleEscape.bind(this));

      this.addEventListener('click', (event) => {
        if (!event.target.closest(this.selectors.close)) return;
        event.preventDefault();
        this.close();
      });

      this.addEventListener('quickview:close', this.close.bind(this));
    }

    addTriggerListeners() {
      document.querySelectorAll(this.selectors.trigger).forEach((trigger) => {
        trigger.addEventListener('click', async (event) => {
          event.preventDefault();
          await this.populateQuickview(trigger.dataset.productHandle, trigger.dataset.template);
          this.open();
        });
      });
    }

    /**
     * Open the quickview modal
     */
    open() {
      const modal = this.querySelector(this.selectors.modal);
      modal.classList.add('is-open');

      modal.addEventListener(
        'transitionend',
        () => {
          trapFocus(modal, modal.querySelector('.quickview__close'));
        },
        { once: true }
      );

      // Test simple : désactiver bodyScroll.lock sur iOS
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

      if (isIOS) {
        // Sur iOS, on gère le scroll manuellement
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        this.originalScrollTop = window.pageYOffset;
        document.body.style.top = `-${this.originalScrollTop}px`;
      } else {
        // Sur desktop, on utilise bodyScroll normalement
        bodyScroll.lock(modal);
      }
    }

    /**
     * Close the quickview modal
     */
    close() {
      const modal = this.querySelector(this.selectors.modal);
      modal.classList.remove('is-open');
      removeTrapFocus(modal.querySelector('.quickview__close'));

      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

      if (isIOS) {
        // Restaurer le scroll iOS manuellement
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        if (this.originalScrollTop) {
          window.scrollTo(0, this.originalScrollTop);
        }
      } else {
        // Desktop : utiliser bodyScroll normalement
        bodyScroll.clear();
      }
    }

    /**
     * Handle the escape key to close the modal
     */
    handleEscape(event) {
      if (event.code.toUpperCase() === 'ESC') this.close();
    }

    /**
     * Fetch the quickview content and populate the modal
     * @param {string} productHandle - The handle of the product to fetch
     */
    async populateQuickview(productHandle, template = '') {
      const url =
        template === ''
          ? `/products/${productHandle}?section_id=quickview`
          : `/products/${productHandle}?section_id=quickview&template=${template}`;
      await fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const data = new DOMParser().parseFromString(html, 'text/html');

          HTMLUpdateUtility.viewTransition(
            this.querySelector(this.selectors.modal),
            data.querySelector(this.selectors.modal)
          );
        })
        .catch((error) => {
          console.error('Error fetching quickview:', error);
        });
    }
  }
  customElements.define('quickview-modal', Quickview);
}
